module.exports = new __parcel__URL__("Mageskill_02.9dcf3fbf.png").toString();